import { render, staticRenderFns } from "./SosCheckbox.vue?vue&type=template&id=77db23d3&scoped=true&lang=pug"
import script from "./SosCheckbox.vue?vue&type=script&lang=js"
export * from "./SosCheckbox.vue?vue&type=script&lang=js"
import style0 from "./SosCheckbox.vue?vue&type=style&index=0&id=77db23d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db23d3",
  null
  
)

export default component.exports